module.exports = __webpack_public_path__ + "img/shangpinguanli.76db0893.png";